<template>
  <b-container fluid class="RwvBookList">
    <h1 v-if="title">{{title}}</h1>
    <!-- ToDo: Add Spinner -->
    <div class="books">
      <div v-for="book in booksWithAds">
          <RwvBookTile
            :book="book">
          </RwvBookTile>
      </div>
      <!-- <VPagination :pages="pages" :currentPage.sync="currentPage" /> -->
    </div>
    <div v-if="isLoadingBooks" class="article-preview">Bücher werden geladen...</div>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import RwvBookTile from "@/components/Books/BookTile";
import VPagination from "@/components/VPagination";
import {
  FETCH_BOOKS,
  FETCH_BOOKS_COUNT
} from "@/store/actions.type";
export default {
  name: "RwvBookList",
  props: {
    title: {
      type: String,
      required: false,
    },
    category: {
      type: String,
      required: false,
      default: ""
    },
    authorSlug: {
      type: String,
      required: false
    },
    tag: {
      type: String,
      required: false
    },
    manufacturerSlug: {
      type: String,
      required: false
    },
    modelSlug: {
      type: String,
      required: false
    },
    variantSlug: {
      type: String,
      required: false
    },
    favorited: {
      type: String,
      required: false
    },
    itemsPerPage: {
      type: Number,
      required: false,
      default: 20
    }
  },
  data() {
    return {
      currentPage: 1
    };
  },
  components: {
    RwvBookTile,
    VPagination
  },
  computed: {
    listConfig() {
        // skip: (this.currentPage - 1) * this.itemsPerPage,
        // limit: this.itemsPerPage,
      const params = {
        include: [
          {
            relation: "variants",
            scope: {
              include: {
                relation: "model"
              }
            }
          }
        ],
        fields: {
          urls: false,
          isLightTheme: false,
          createdAt: false,
          updatedAt: false,
          image: false
        }
      }
      const offset = (this.currentPage - 1) * this.itemsPerPage;
      return params
    },
    pages() {
      if (this.isLoadingBooks || this.booksCount <= this.itemsPerPage) {
        return [];
      }
      return [
        ...Array(Math.ceil(this.booksCount / this.itemsPerPage)).keys()
      ].map(e => e + 1);
    },
    filterdBooks() {
      var me = this;
      var booksToDisplay = [];

      if (me.manufacturerSlug || me.authorSlug) {
        return me.books.filter(function (book) {
          // filter books variants
          var variantApplies = true
          var authorApplies = true

          if (me.authorSlug) {
            book.authorSlug = me.authorSlug
          }

          if (me.manufacturerSlug) {
            var variants = book.variants.filter(function(variant) {
              if (me.variantSlug) {
                return variant.slug == me.variantSlug
              } else if (me.modelSlug) {
                return variant.modelSlug == me.modelSlug
              } else {
                return variant.model.manufacturerSlug == me.manufacturerSlug
              }
            })
            variantApplies = (variants.length > 0)
          }

          return variantApplies && authorApplies;
        });
      } else {
        return me.books
      }
    },
    booksWithAds() {
      // Batch is at the time of writing at 9, so this will insert ads at the beginning, the middle and the end.
      // first ad at index 0
      var books = JSON.parse(JSON.stringify(this.filterdBooks))

      var booksLength =  books.length

        // books.unshift({
        //   slug: "ad-random-1",
        //   ad_client: "ca-pub-0281378002600422",
        //   ad_slot: "2207459503",
        //   layout_key: "-6t+ed+2i-1n-4w"
        // })
      if (booksLength >= 5) {
        books.splice(4, 0, {
          ad_client: "ca-pub-0281378002600422",
          ad_slot: "2207459503",
          layout_key: "-6t+ed+2i-1n-4w"
        });
        if (booksLength >= 17) {
          // 16 books and 1 ad therefor 17th, but index is 16
          books.splice(17, 0, {
            ad_client: "ca-pub-0281378002600422",
            ad_slot: "2207459503",
            layout_key: "-6t+ed+2i-1n-4w"
          });
        }
      }

      // Next +12

      // if (articlesLength >= 4) {
      //   var index =  4 + 1 // + 1 because of existing ad

      //   articles.splice(index, 0, {
      //     ad_client: "ca-pub-0281378002600422",
      //     ad_slot: "2976302612"
      //   });

      //   if (articlesLength >= 8) {
      //     index = 8 + 2 // + 2 because of existing ad

      //     articles.splice(index, 0, {
      //       ad_client: "ca-pub-0281378002600422",
      //       ad_slot: "2976302612"
      //     });
      //   }
      // }
      return books
    },
    ...mapGetters(["booksCount", "isLoadingBooks", "books", "defaultParamsBooks"])
  },
  watch: {
    currentPage(newValue) {
      // this.listConfig.skip = (newValue - 1) * this.itemsPerPage;
      this.fetchBooks();
    },
  },
  mounted() {
    this.$store.dispatch(FETCH_BOOKS_COUNT);
    this.fetchBooks();
  },
  methods: {
    fetchBooks() {
      // this.$store.dispatch(FETCH_BOOKS, this.listConfig);

      // if (this.category == "") {
      //   this.defaultParamsBooks.where = {
      //     "category": "repair"
      //   }
      // } else {
      //   this.defaultParamsBooks.where = {
      //     "category": this.category
      //   }
      // }

      console.log(this.defaultParamsBooks)
      this.$store.dispatch(FETCH_BOOKS, JSON.parse(JSON.stringify(this.defaultParamsBooks)));
    },
    resetPagination() {
      this.listConfig.skip = 0;
      this.currentPage = 1;
    }
  }
};
</script>

<style lang="scss">
// $five-images-width: 975px;
$four-images-width: 780px;
$three-images-width: 585px;
$two-images-width: 390px;
$one-images-width: 195px;
.VPagination {
  float:left;
  width: 100%;
  margin-top: 2rem;
}
.books {
  margin: auto;
  max-width: $one-images-width;
  overflow: hidden;
  .RwvBookTile {
    width: 100%;
    height: 275px;
  }
  @media screen and (min-width: $two-images-width) {
    max-width: $two-images-width;
    .RwvBookTile {
      width: 50%;
      &.adTile {
        width: 100%;
      }
    }
  }
  @media screen and (min-width: $three-images-width) {
    max-width: $three-images-width;
    .RwvBookTile {
      width: 33.3%;
      &.adTile {
        width: 66.6%;
      }
    }
  }
  @media screen and (min-width: $four-images-width) {
    max-width: $four-images-width;
    .RwvBookTile {
      width: 25%;
      &.adTile {
        width: 50%;
      }
      opacity: 0.65;
      &:hover, &:active, &:focus {
        opacity: 1;
      }
    }
  }
  // @media screen and (min-width: $five-images-width) {
  //   max-width: $five-images-width;
  //   .RwvBookTile {
  //     width: 20%;
  //   }
  // }
}
</style>
